var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 12.5C9.86667 12.5 8.46956 12.1804 7.10867 11.5413C5.74778 10.9022 4.54222 10.0578 3.492 9.008C2.44178 7.95822 1.59733 6.75267 0.958667 5.39133C0.32 4.03 0.000444444 2.63289 0 1.2C0 1 0.0666666 0.833333 0.2 0.7C0.333333 0.566667 0.5 0.5 0.7 0.5H3.4C3.55556 0.5 3.69444 0.55 3.81667 0.65C3.93889 0.75 4.01111 0.877778 4.03333 1.03333L4.46667 3.36667C4.48889 3.52222 4.486 3.664 4.458 3.792C4.43 3.92 4.36622 4.03378 4.26667 4.13333L2.66667 5.76667C3.13333 6.56667 3.71667 7.31667 4.41667 8.01667C5.11667 8.71667 5.88889 9.32222 6.73333 9.83333L8.3 8.26667C8.4 8.16667 8.53067 8.09178 8.692 8.042C8.85333 7.99222 9.01156 7.97822 9.16667 8L11.4667 8.46667C11.6222 8.5 11.75 8.57511 11.85 8.692C11.95 8.80889 12 8.94489 12 9.1V11.8C12 12 11.9333 12.1667 11.8 12.3C11.6667 12.4333 11.5 12.5 11.3 12.5Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePhone);
export default __webpack_public_path__ + "static/media/blue-phone.8284a9d7965d926afd79e70d3bcff7bb.svg";
export { ForwardRef as ReactComponent };